import { HttpClient } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';

import { Storage, getDownloadURL, ref } from '@angular/fire/storage';
import { AuthService } from 'src/app/auth.service';
import { environment } from 'src/environments/environment';
import { MySpaceService } from './my-space.service';

@Component({
  selector: 'app-my-space',
  templateUrl: './my-space.component.html',
  standalone: false,
})
export class MySpaceComponent implements OnInit {
  user;
  storage;
  constructor(
    private settingsService: MySpaceService,
    private authService: AuthService,
    private http: HttpClient,
    private mySpaceService: MySpaceService
  ) {
    this.storage = inject(Storage);
  }

  ressourceExists(link) {
    return new Promise((resolve, reject) => {
      this.http.get(link).subscribe(
        (res) => {
          resolve(true);
        },
        (err) => {
          resolve(false);
        }
      );
    });
  }

  async getDownloadURL(url) {
    try {
      const reference = ref(this.storage, url);
      return await getDownloadURL(reference);
    } catch (error) {
      return 'assets/images/no_user.png';
    }
  }

  isAdmin() {
    return this.authService.isAdmin();
  }
  isWriter() {
    return this.authService.isWriter();
  }
  getMySpaceCustomizerTab() {
    return '/myspace/personalize-app/' + this.mySpaceService.getSavedCustomizeAppTab();
  }

  getUser() {
    const currentUser = this.authService.userInfo();
    if (currentUser._id) {
      this.settingsService.getUserProfile(currentUser._id).subscribe(async (user) => {
        this.user = user;
        if (this.user.photo != 'null' && this.user.photo) {
          const actualFileName = user.photo.split(`/${environment.profilePictureBucketName}/`)[1];
          this.getDownloadURL(`gs://${environment.profilePictureBucketName}/${actualFileName}`)
            .then((photoLink) => {
              this.user.photo = photoLink;
            })
            .catch((err) => {
              console.error('error while getting profile photo link');
            });
        }
        this.passUser(user);
      });
    }
  }

  passUser(user) {
    this.settingsService.passUser(user);
  }
  ngOnInit() {
    if (!this.user) {
      this.getUser();
    }
  }
}
